import { CloseOutlined } from '@ant-design/icons';
import inquiryService from '@root/modules/Warehouse/Inquiry/service/inquiry';
import { Button, Form, message, Spin, Upload, UploadProps } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import { UploadFile } from 'antd/lib/upload/interface';
import { useState } from 'react';
import { useParams } from 'react-router';

interface inquiryId {
  id: string;
}
interface Prop {
  onSubmit: () => void;
  _getData: () => void;
  inquiryId?: Number;
  statusWarehouse?: string;
}
const CmtCreate = ({ onSubmit, _getData, statusWarehouse }: Prop) => {
  const [selectedFileCreate, setSelectedFileCreate] = useState([] as any);
  const [fieldId, setFieldId] = useState([] as any);
  const [fileList, setFileList] = useState<UploadFile[] | any>([]);
  const [loading, setLoading] = useState(false);

  const inquiryId: inquiryId = useParams();

  const handleUploadCreate = (files: any) => {
    const uploaded = [...selectedFileCreate];
    files.some((file: any) => {
      if (uploaded.findIndex((f) => f.name === file.name) === -1) {
        uploaded.push(file);
      }
      setSelectedFileCreate(uploaded);
    });
  };

  const handleFileCreate = (e: any) => {
    const chosenFiles = Array.prototype.slice.call(e);
    handleUploadCreate(chosenFiles);
  };

  const handleCreate = async (values: any) => {
    try {
      if (
        fileList.length === 0 &&
        (statusWarehouse === 'WarehouseApproved' ||
          statusWarehouse === 'SellerApproved')
      ) {
        message.error('Please upload file!');
      }
      //  else if (
      //   !values.comment &&
      //   fileList.length === 0 &&
      //   (statusWarehouse !== 'WarehouseApproved' ||
      //     statusWarehouse !== 'SellerApproved')
      // ) {
      //   message.error('Please input comment and upload file!');
      // }
      else {
        setLoading(true);

        if (fileList.length > 0) {
          const formData = new FormData();
          for (let i = 0; i < fileList.length; i++) {
            formData.append('files', fileList[i].originFileObj || fileList[i]);
          }
          const uploadData = await inquiryService.postUploadImg(formData);
          for (let i = 0; i < uploadData.data.length; i++) {
            setFileList([...fileList]);
            fieldId.push(uploadData.data[i].id);
          }
        }

        const text = {
          comment: values.comment ?? '',
          quotationId: inquiryId.id,
          owner: 'Warehouse',
          documents: fieldId
        };
        const postNewCmt = await inquiryService.postCommentWare(
          inquiryId.id,
          text
        );
        setLoading(false);
        message.success('Create new comment success!');
        _getData();
        onSubmit();
      }
    } catch (error) {}
  };
  const removeItemIndex = (index: number) => {
    setFileList([
      ...fileList.filter(
        (selected: any) => fileList.indexOf(selected) !== index
      )
    ]);
  };
  const validateFileType = (
    { type }: UploadFile,
    allowedTypes: string[] = ['image/jpeg', 'image/png']
  ) => {
    return allowedTypes.includes(type!);
  };

  const props: UploadProps = {
    onChange({ fileList: newFileList }) {
      setFileList(newFileList);
    },
    beforeUpload: (file) => {
      const isAllowedType = validateFileType(file);
      if (!isAllowedType) {
        message.error(`${file.name} is not JPEG file`);
        return false;
      }
      setFileList((prev: any) => {
        if (prev.length < 5) {
          return [...prev, file];
        }
        return prev;
      });
      setFileList([...fileList, file]);
      return false;
    }
  };

  return (
    <Spin spinning={loading} style={{ background: 'red' }}>
      <Form onFinish={handleCreate}>
        <div style={{ display: 'flex', gap: '10px' }}>
          <Form.Item
            name="upload"
            rules={[{ required: true, message: 'Please upload files' }]}
          >
            <div className="attachUp" style={{ marginBottom: '10px' }}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between'
                }}
              >
                <>
                  <p style={{ marginBottom: '0px' }}>Warehouse</p>
                </>

                <Upload
                  {...props}
                  multiple
                  fileList={fileList}
                  accept=".png, .jpg, .jpeg"
                  maxCount={5}
                  showUploadList={false}
                >
                  <Button
                    style={{
                      background: '#3c3d5f',
                      border: 'none',
                      color: 'white',
                      borderRadius: '8px'
                    }}
                    // disabled={
                    //   statusWarehouse === 'WarehouseApproved' ||
                    //   statusWarehouse === 'SellerApproved'
                    //     ? true
                    //     : false
                    // }
                  >
                    Upload
                  </Button>
                </Upload>
              </div>
              <div
                className="scrollImg"
                style={{
                  height: '85px',
                  overflowY: 'scroll',
                  overflowX: 'scroll',
                  width: '320px'
                }}
              >
                {fileList.map((item: any, index: number) => (
                  <li
                    key={index}
                    style={{ display: 'flex', alignItems: 'center' }}
                  >
                    <div className="">{item.name}</div>

                    <span
                      style={{ cursor: 'pointer', display: 'flex' }}
                      onClick={() => removeItemIndex(index)}
                    >
                      <CloseOutlined />
                    </span>
                  </li>
                ))}
              </div>
            </div>
          </Form.Item>
          <Form.Item
            name="comment"
            rules={[
              {
                required:
                  statusWarehouse === 'WarehouseApproved' ||
                  statusWarehouse === 'SellerApproved'
                    ? false
                    : true,
                message: 'Please input message'
              },
              {
                max: 150,
                message: 'Character must be less than 150!'
              }
            ]}
            style={{ width: '100%' }}
          >
            <div
              className="commentCard"
              style={{ marginBottom: '10px', height: '145px' }}
            >
              <div
                className="wrapTitle"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between'
                }}
              >
                <p>Warehouse</p>
              </div>
              <p className="descript" style={{ marginBottom: '0px' }}>
                <TextArea
                  disabled={
                    statusWarehouse === 'WarehouseApproved' ||
                    statusWarehouse === 'SellerApproved'
                      ? true
                      : false
                  }
                  style={{ resize: 'none' }}
                  cols={4}
                />
              </p>

              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'end',
                  marginTop: '5px'
                }}
              >
                <Button
                  style={{
                    background: '#3c3d5f',
                    border: 'none',
                    color: 'white',
                    borderRadius: '8px'
                  }}
                  htmlType="submit"
                  type="primary"
                  // disabled={
                  //   statusWarehouse === 'WarehouseApproved' ||
                  //   statusWarehouse === 'SellerApproved'
                  //     ? true
                  //     : false
                  // }
                >
                  Send
                </Button>
              </div>
            </div>
          </Form.Item>
        </div>
      </Form>
    </Spin>
  );
};

export default CmtCreate;
